import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Holidays - finally some time to work!",
  "description": "",
  "published": "2009-12-21T00:00:00.000Z",
  "redirect_from": ["/blog/holidays-finally-some-time-to-work/swizec/1021"],
  "categories": "Christmas, food for thought, Holidays, life, New Year, People and Society, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Traditionally new year's and Christmas have held a special place in the heart of students all over the world - it's usually a time when everybody gets a winter break, that proper time when you're not studying for exams, when you're not doing anything special, when you're just enjoying yourself.`}</p>
    <p>{`Lovely.`}</p>
    <p>{`Bullshit!`}</p>
    <p>{`The real reason students love this time of year is that finally there are no classes, no tutorials, no whatevers - it's just free time where you can actually get some work done without everyone getting in your damn way.`}</p>
    <p>{`Of course there are many who disagree with me and actually `}<em parentName="p">{`do`}</em>{` take it easy over the holidays, but most of them don't strain themselves very much anyway. For them, and those of us who like to work during holidays, here's a few special comics describing just what the professors think winter break is for.`}</p>
    <p><img parentName="p" {...{
        "src": "/5a17a259d347f2f4b200a5ddb5043426/comics-archive-phd120605s.gif",
        "alt": null,
        "title": "PHD Comics"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "/65b9e4d9af754ffde8dee4e234cb0279/comics-archive-phd122107s.gif",
        "alt": null,
        "title": "PHD Comics"
      }}></img><img parentName="p" {...{
        "src": "/cb8d208ef5377fa392f7d444dd20ea74/comics-archive-phd122407s.gif",
        "alt": null,
        "title": "PHD Comics"
      }}></img><img parentName="p" {...{
        "src": "/f7a58c35581b860dfc47d8313e9bcfbf/comics-archive-phd122607s.gif",
        "alt": null,
        "title": "PHD Comics"
      }}></img><img parentName="p" {...{
        "src": "/1748c5a5677260684069041aa6d0c50c/comics-archive-phd122807s.gif",
        "alt": null,
        "title": "PHD Comics"
      }}></img></p>
    <p>{`So what are you doing over the holidays?`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/716c3e41-e420-46b9-ad53-d4fa30c57736/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=716c3e41-e420-46b9-ad53-d4fa30c57736",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      